import { Link } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import HerosectionHeader from "../../Componet/Herosection/HerosectionHeader";
import "./howitworks.css";

const steps = [
    {
        number: "01",
        icon: "las la-calendar-check",
        title: "Book Your Inspection",
        description: "Choose the inspection you need, enter your vehicle information, and select a convenient date and time.",
    },
    {
        number: "02",
        icon: "las la-credit-card",
        title: "Complete Your Payment",
        description: "Securely complete your payment online to confirm your scheduled inspection.",
    },
    {
        number: "03",
        icon: "las la-video",
        title: "Join Your Live Video Inspection",
        description: "At your scheduled time, join a live video call from your phone. Your inspector will guide you through each required inspection point on your vehicle.",
    },
    {
        number: "04",
        icon: "las la-file-alt",
        title: "Receive Your Inspection Form",
        description: "Once the inspection is complete, your inspection form will be reviewed and sent directly to your email.",
    },
];

const REQUIREMENTS = [
    {
        title: "Your Vehicle",
        description: "Have the vehicle available and accessible during your scheduled inspection.",
    },
    {
        title: "A Smartphone",
        description: "Use a phone with a working camera and astable internet connection.",
    },
    {
        title: "Good Lighting",
        description: "Make sure the vehicle is in a well-lit area so the required components can be clearly inspected.",
    },
    {
        title: "A Few Minutes of Your Time",
        description: "Follow your inspector's instructions as they guide you through the inspection.",
    }
];

const HowItWorks = () => {
    return (
        <>
            <HerosectionHeader folder1={"pages"} folder2={"Account"} name={"How It Works"} />
            <section className="how-it-works-section">
                <Container>
                    {/* Section Header */}
                    <div className="how-it-works-header text-center">
                        <h2 className="how-it-works-title">
                            Complete Your Vehicle Inspection in 4 Simple Steps
                        </h2>

                        <p className="how-it-works-description">
                            Complete your vehicle inspection remotely through a live video call. Choose your inspection, schedule a convenient
                            time, and follow your inspector's guidance from your phone.
                        </p>
                    </div>

                    {/* Steps */}
                    <Row className="how-it-works-steps">
                        {steps.map((step, index) => (
                            <Col md={6} lg={3} key={step.number}>
                                <div className="how-step">

                                    {/* Icon + Number */}
                                    <div className="how-step-top">
                                        <div className="how-step-icon">
                                            <i className={step.icon}></i>

                                            <span className="how-step-number">
                                                {step.number}
                                            </span>
                                        </div>
                                    </div>

                                    {/* Connector */}
                                    {index < steps.length - 1 && (
                                        <div className="how-step-line">
                                            <i className="las la-arrow-right"></i>
                                        </div>
                                    )}

                                    {/* Content */}
                                    <div className="how-step-content">
                                        <h4>{step.title}</h4>
                                        <p>{step.description}</p>
                                    </div>
                                </div>
                            </Col>
                        ))}
                    </Row>
                </Container>
                <div className="container pt-10 pb-5">
                    <h2 className="fw-bold text-dark text-center">
                        What You'll Need
                    </h2>
                    <div className="row border rounded g-0 mt-3">
                        {REQUIREMENTS.map((item, index) => (
                            <div
                                key={item.title}
                                className={`col-6 col-md-3 text-center px-4 py-4 ${index !== REQUIREMENTS.length - 1 ? "border-end" : ""
                                    }`}
                            >
                                <div className="fw-bold text-dark mb-1">{item.title}</div>
                                <div className="text-secondary small">{item.description}</div>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="container pt-5 pb-5 text-center">
                    <h2 className="fw-bold text-dark text-center">
                        Ready to Get Started?
                    </h2>
                    <p>
                        Complete your vehicle inspection without making a trip to an inspection shop
                    </p>
                    <Link className="btn btn-dark mt-2" aria-label="Order a pre-purchase car inspection" to="/quotation">Book Your Inspection</Link>
                </div>
            </section>
        </>
    );
};

export default HowItWorks;
